const GoogleMap = ({ mapLink }) => {
  return (
    <section className='pb-[80px]'>
      <div className='container p-6 mx-auto'>
        <iframe
          src={mapLink}
          width='100%'
          height='400'
          style={{ border: 0, borderRadius: '50px' }}
          allowFullScreen=''
          aria-hidden='false'
          tabIndex='0'
          title='office-location'
        />
      </div>
    </section>
  );
};

export default GoogleMap;
